<template>
  <div class="login limiter"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    if (this.$session.exists()) {
      let std_portal = this.$session.get("portal_user");
      this.$emit("switch_nav", { type: "student", data: std_portal });
      this.$router.push({ name: "StudentPortalPublicHome" });
    } else this.$router.replace({ name: "StudentPortalPublicLogin" });
  },
  methods: {},
  created() {
    this.$emit("hide_nav");
  },
};
</script>

<style></style>
